import axiosInstance from './axios';

const getLoggedinUser = () => {
  return axiosInstance.get('/auth/user');
};

const loginUser = ({ email, password }) => {
  return axiosInstance.post('/auth/login', { email, password });
};

const logoutUser = () => {
  return axiosInstance.post('/auth/logout', {});
};

export { logoutUser, loginUser, getLoggedinUser };
